import { getErrorMessage } from "@/core/api/helpers"
import { useAppDispatch } from "@/redux/hooks"
import { useAddAdminDNCMutation } from "@/redux/services/adminDncApi"
import { setToast } from "@/redux/toastSlice"

export const useAdminAddDNC = () => {
  const dispatch = useAppDispatch()
  const [addAdminDNC, response] = useAddAdminDNCMutation()

  const handleAddAdminDNC = async (body: { records: string[] }) => {
    try {
      const response = await addAdminDNC(body).unwrap()
      if (response) {
        dispatch(
          setToast({
            show: true,
            variant: "success",
            message: "Success add contact",
          }),
        )
      }
    } catch (error: any) {
      const message = getErrorMessage(error)
      dispatch(
        setToast({
          show: true,
          variant: "error",
          message,
        }),
      )
      throw new Error(message)
    }
  }

  return { addAdminDNC: handleAddAdminDNC, response }
}
